import * as enums from '../../enums';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedCrop = {
    id: 3,
    isArchived: false,
    seed: {
        id: 1,
        isDefault: false,
        vendor: 'Foo',
        name: 'Bar',
        localizedName: 'Bar',
        rpgCode: '9',
        rpgSubcode: '89',
        isPerennial: false,
        version: 0,
        cropUsage: enums.TemplateCropUsage.production,
        isMaizyCompatible: false
    },
    lastCycle: {
        id: 1,
        cropId: 8,
        startedAt: '1612874239',
        completedOn: '1612874239'
    },
    plotId: 6
};
const mock = {
    get: mockedRequester(mockedCrop, 'crops.get'),
    getAll: mockedRequester([mockedCrop], 'crops.getAll'),
    getMany: mockedRequester(mockedPaginatedResponse([mockedCrop]), 'crops.getMany'),
    create: mockedRequester(mockedCrop, 'crops.create'),
    update: mockedRequester(mockedCrop, 'crops.update')
};
export default mock;
